import { render, staticRenderFns } from "./JsonTextarea.vue?vue&type=template&id=2dedd9aa&"
import script from "./JsonTextarea.vue?vue&type=script&lang=js&"
export * from "./JsonTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports